import { SideMenu } from "../models/proj.model";

export const SIDE_MENU_CONSTANTS: SideMenu = {
    MENU_ITEMS: [
        {
            section: '',
            items: [
                {
                    label: 'Home',
                    icon: 'ti ti-home',
                    route: '/home',
                    disabled: true
                },

            ]
        },
        {

            section: 'Digital Library',
            items: [
                // {
                //     label: 'Digital Library',
                //     icon: 'ti ti-server',
                //     route: '/digital-library',
                //     disabled: false
                // },
                // {
                //     label: 'Workspace',
                //     icon: 'ti ti-stack-2',
                //     route: '/workspace',
                //     disabled: true
                // }, 
                
                {
                    label: 'Station',
                    icon: 'ti ti-train',
                    route: '/digital-library',
                    disabled: false
                },
                // {
                //     label: 'Routes',
                //     icon: 'ti ti-route',
                //     route: '/workspace',
                //     disabled: true
                // },
                // {
                //     label: 'GIS Data',
                //     icon: 'ti ti-map-pin',
                //     route: '/workspace',
                //     disabled: true
                // },
                // {
                //     label: 'Unit Cost',
                //     icon: 'ti ti-moneybag',
                //     route: '/workspace',
                //     disabled: true
                // },
                // {
                //     label: 'Engineering Rules',
                //     icon: 'ti ti-device-desktop-cog',
                //     route: '/workspace',
                //     disabled: true
                // }
            ]
        },
        {
            section: 'MY MODULES',
            items: [
                {
                    label: 'RAPID Railway Alignment Design',
                    icon: 'ti ti-git-branch',
                    route: '/rapid-railway-alignment-design',
                    disabled: true
                },
                {
                    label: 'RAPID ESP',
                    icon: 'ti ti-file-description',
                    route: '/rapid-esp',
                    disabled: true
                },
                {
                    label: 'RAPID SIP',
                    icon: 'ti ti-broadcast',
                    route: '/rapid-sip',
                    disabled: true
                },
                {
                    label: 'RAPID LOP',
                    icon: 'ti ti-layout-sidebar',
                    route: '/rapid-lop',
                    disabled: true
                },
                {
                    label: 'RAPID Kavach',
                    icon: 'ti ti-shield',
                    route: '/rapid-kavach',
                    disabled: true
                },
            ]
        },
        {
            section: 'USER MANAGEMENT',
            items: [
                {
                    label: 'Audit Logs',
                    icon: 'ti ti-clipboard-list',
                    route: 'usermgmt/audit-logs',
                    disabled: true
                },
                {
                    label: 'Organizations',
                    icon: 'ti ti-building',
                    route: 'usermgmt/customer',
                    resourceName: 'User Management',
                    resourceTypeName: 'Application',
                    disabled: false
                },
                {
                    label: 'Applications',
                    icon: 'ti ti-layout-2',
                    route: 'usermgmt/applications',
                    resourceName: 'User Management',
                    resourceTypeName: 'Application',
                    disabled: false
                },
                {
                    label: 'Roles',
                    icon: 'ti ti-users-plus',
                    route: 'usermgmt/roles',
                    resourceName: 'User Management',
                    resourceTypeName: 'Application',
                    disabled: false
                },
                {
                    label: 'Users',
                    icon: 'ti ti-users',
                    route: 'usermgmt/users',
                    resourceName: 'User Management',
                    resourceTypeName: 'Application',
                    disabled: false
                },
            ]
        },

    ]
}


